module.exports = __webpack_public_path__ + "static/img/7.9b20370.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/7.png
// module id = 0R04
// module chunks = 0